import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { listMyFavorites } from "@/lib/user.functions";
import { TeachingCard } from "@/components/teaching-card";
import { Heart } from "lucide-react";

export const Route = createFileRoute("/_authenticated/favoritos")({
  head: () => ({ meta: [{ title: "Meus favoritos · Beit Tefilah Rechovot" }] }),
  component: FavoritosPage,
});

function FavoritosPage() {
  const fn = useServerFn(listMyFavorites);
  const { data, isLoading } = useQuery({ queryKey: ["my-favorites"], queryFn: () => fn() });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="flex items-center gap-2 font-serif text-3xl font-semibold text-primary">
          <Heart className="h-7 w-7 text-destructive" /> Meus favoritos
        </h1>
        <p className="mt-1 text-muted-foreground">Ensinos que você salvou para revisitar.</p>
      </div>

      {isLoading ? (
        // Um único espaço reservado, com altura parecida com o resultado final,
        // evita que a página "encolha" quando os favoritos aparecem.
        <div
          className="h-56 animate-pulse rounded-xl bg-secondary"
          role="status"
          aria-label="Carregando"
        />
      ) : (data?.length ?? 0) === 0 ? (
        <div className="rounded-xl border border-dashed border-border p-16 text-center">
          <Heart className="mx-auto mb-3 h-8 w-8 text-muted-foreground" />
          <p className="text-muted-foreground">Você ainda não favoritou nenhum ensino.</p>
        </div>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {data!.map((t: any) => (
            <TeachingCard key={t.id} teaching={t} />
          ))}
        </div>
      )}
    </div>
  );
}
